import images from "./images";
import { FaCertificate, FaUtensils, FaCocktail, FaCalendarAlt } from "react-icons/fa";

const About = {
    sub: "About Us",
    heading: "Discover Our Culinary Passion and Experience Exquisite Dining",
    description: [
        "At Bistro, we have been dedicated to serving exceptional cuisine and providing outstanding catering services for over 20 years. Our chefs craft each dish with the finest ingredients and a passion for flavor.",
        "Our mission is to deliver a memorable dining experience and cater to your events with the highest level of professionalism and creativity."
    ],
    experience: {
        year: 20,
        text: "years of excellence",
    },
    points: [
        {
            icon: <FaCertificate />,
            title: "Expert Chefs",
        },
        {
            icon: <FaUtensils />,
            title: "Gourmet Cuisine",
        },
        {
            icon: <FaCocktail />,
            title: "Signature Drinks",
        },
        {
            icon: <FaCalendarAlt />,
            title: "Event Catering",
        },
    ],
    image: {
        src1: images.about1,
        src2: images.about2,
        src3: images.about3,
        alt1: "Event Setup",
        alt2: "Chef Cooking",
        alt3: "Signature Dish",
    },
    button: {
        text: "Contact Us",
        link: "Contact-us",
    }
};

export default About;